import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import DeactivateVirtualCardContent from 'src/app/DeactivateVirtualCardContent/DeactivateVirtualCardContent'
import {
  selectVirtualCardIdFromRoute,
  selectVirtualCardListModel,
} from 'src/app/DeactivateVirtualCardContent/redux/deactivateVirtualCardContent.selectors'
import { useFlyoutDispatch } from 'src/hooks'
import { connectedReplace } from 'src/navigation/Lnk'
import { deactivateBillPayCardUrl } from 'src/navigation/urls'
import {
  getVirtualCard,
  getVirtualCardPermissions,
} from 'src/redux/actions/data/virtualCards.actions'

const DeactivateVirtualCard: React.FC = () => {
  const dispatch = useFlyoutDispatch()
  const virtualCardId = useSelector(selectVirtualCardIdFromRoute)
  const virtualCard = useSelector(selectVirtualCardListModel)

  useEffect((): void => {
    dispatch(getVirtualCard(virtualCardId))
    dispatch(getVirtualCardPermissions(virtualCardId))
  }, [virtualCard?.status, virtualCardId])

  useEffect(() => {
    if (virtualCard === undefined) return

    if (virtualCard.isBillPay) {
      // user is trying to access a bill pay card, redirect to the bill pay url
      dispatch(connectedReplace(deactivateBillPayCardUrl(virtualCardId)))
    }
  }, [virtualCard])

  return <DeactivateVirtualCardContent virtualCard={virtualCard} />
}

export default DeactivateVirtualCard
